module.exports = require("react-dotdotdot");